<template>
  <div>
    <Toolbar class="mb-4">
      <template #right> Settings </template>
    </Toolbar>

    <div class="form-card row">
      <div class="col-md-6">
        <div class="mb-3">
          <label for="loginMethod" class="form-label required">
            Login / OTP Delivery Method
          </label>
          <Dropdown
            id="loginMethod"
            v-model="body.loginMethod"
            class="w-100"
            :options="loginMethodOptions"
            optionLabel="label"
            optionValue="value"
          />
          <small class="form-text text-muted">
            Controls how customers receive the verification code (TAN) when
            logging in: by SMS to their phone, by email, or both.
          </small>
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3 text-center">
          <Button
            label="Save"
            icon="pi pi-pencil"
            class="ml-2 p-button-info"
            @click="update()"
            :disabled="disabledAdd"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body: {
        loginMethod: "phone",
      },
      loginMethodOptions: [
        { label: "Phone (SMS) only", value: "phone" },
        { label: "Email only", value: "email" },
        { label: "Phone (SMS) and Email", value: "both" },
      ],
      disabledAdd: false,
    };
  },
  methods: {
    getData() {
      this.$http.get(`settings`).then(
        (res) => {
          if (res.data && res.data.loginMethod) {
            this.body.loginMethod = res.data.loginMethod;
          }
        },
        (err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    },
    update() {
      this.disabledAdd = true;
      this.$http.post(`settings`, this.body).then(
        () => {
          this.disabledAdd = false;
          this.$toast.add({
            severity: "success",
            summary: "Done Successfully",
            detail: "Updated Successfully",
            life: 3000,
          });
          this.getData();
        },
        (err) => {
          this.disabledAdd = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    },
  },
  created() {
    this.getData();
  },
};
</script>
